import { useCallback, useEffect, useState } from 'react';

import { apiOrchestrator } from 'services/apiService';

import type { AutomationRule } from '../types/rule';

export function useAutomation() {
  const [rules, setRules] = useState<AutomationRule[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const fetchRules = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await apiOrchestrator.get<AutomationRule[]>('/automations/rules');
      setRules(r.data ?? []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRules();
  }, [fetchRules]);

  return { rules, loading, error, reload: fetchRules };
}
